import { action, computed, observable, makeAutoObservable } from 'mobx';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { CompetitionModel } from 'src_common/common/websocket2/models/CompetitionModel';
import { AppState } from 'src/AppState/AppState';
import { EventsCollectionQueryModel } from 'src_common/common/websocket2/models/EventsCollectionQueryModel';
import { EventsCollectionQueryType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { getSportStartTime } from 'src/components/CustomersBar/EventsTab/utils';

export class TrapChallengeState {
    @observable selectedEvent: EventModel | null = null;
    @observable selectedCompetition: CompetitionModel | null = null;

    constructor(private readonly appState: AppState) {
        makeAutoObservable(this);
    }

    public allEventsList = (): EventsCollectionQueryModel | null => {
        const query: EventsCollectionQueryType = {
            sport: ['greyhoundracing'],
            'startTime[from]': getSportStartTime('greyhoundracing'),
            filterMarketStatus: {
                noteq: ['settled'],
            },
        };

        return this.appState.websocketV2.getEventQuery(query);
    };

    @computed public get isLoading(): boolean {
        return this.allEventsList() === null;
    }

    @computed public get allEventsWithTrapChallenge(): Array<EventModel> {
        const eventsQuery = this.allEventsList()?.events;
        const eventsOut: Array<EventModel> = [];

        if (eventsQuery === undefined) {
            return eventsOut;
        }

        const hasAnyMarketTrapChallenge = (eventId: number): boolean => {
            const markets = this.appState.sdkStaff.models.getEventMarkets(eventId) ?? [];

            for (const market of markets) {
                if (market.tags['trap-challenge'] === 'yes') {
                    return true;
                }
            }

            return false;
        };

        for (const event of eventsQuery) {
            const hasTrapChallenge = hasAnyMarketTrapChallenge(event.id);
            // const eventTagModel = this.appState.websocketV2.getEventTag(event.id);
            // const hasTrapChallenge = eventTagModel?.hasAnyMarketTrapChallenge();
            if (hasTrapChallenge === true) {
                const eventModel = this.appState.websocketV2.getEvent(event.id);
                eventModel !== null ? eventsOut.push(eventModel) : null;
            }
        }

        return eventsOut;
    }

    @computed public get getCompetitionForView(): Array<CompetitionModel> {
        const competitions: Array<CompetitionModel> = [];
        const events = this.allEventsWithTrapChallenge;

        events.forEach((event) => {
            const competition = this.appState.websocketV2.getCompetitionModel(event.competition);
            if (competition !== null) {
                competitions.push(competition);
            }
        });

        return [...new Map(competitions.map((competition) => [competition.name, competition])).values()];
    }

    @action public onCompetitionSelect = (competition: CompetitionModel): void => {
        this.selectedCompetition = competition;
    };

    @action public onSelectEvent = (event: EventModel | null): void => {
        this.selectedEvent = event;
    };
}
